<delivery-countdown-timer-form
  [formGroup]="formGroup"
  [displayRules]="displayRules"
  [displayRulesEntities]="displayRulesEntities"
  [shopCurrencySymbol]="shopCurrencySymbol"
  [shippingMethods]="shippingMethods"></delivery-countdown-timer-form>
